import type { Anim } from '../../../shared/ids';

// 같은 스테이지를 달리는 다른 사람을 그리는 모습: 내 몸(2-controllers/game/player.js의 Player.draw)과 같은 몸짓 말을 쓴다. 적·장애물로 안 보이게 살짝 투명하다.
export const STAGE_PEER_ALPHA = 0.62;
export type StagePeerState = { kind: string; face: 1 | -1; st: Anim; vx: number; vy: number; t: number; runT: number; blinkT: number };

// G.drawCritter가 받는 모습 옵션 (kind, face, legs, arm, eyes, alpha …)
export function stagePose(a: StagePeerState): Record<string, unknown> {
  const o: Record<string, unknown> = { kind: a.kind, face: a.face, alpha: STAGE_PEER_ALPHA };
  if (a.st === 'dash') { o.eyes = 'shut'; o.legs = [1, 1, 1, 1]; o.col = '#ffe2c4'; }
  else if (a.st === 'jump') {
    if (a.vy < -40) { o.armL = -1; o.armR = -1; o.legs = [2, 2, 2, 2]; o.eyeY = -1; }
    else if (a.vy > 60) { o.armL = -3; o.armR = -3; o.legs = [2, 1, 1, 2]; o.eyeY = 1; }
    else { o.armL = -2; o.armR = -2; o.legs = [1, 2, 2, 1]; }
  } else if (a.st === 'walk') {
    const f = ((a.runT * 13) | 0) % 4;
    o.legs = f === 0 ? [2, 1, 2, 1] : f === 2 ? [1, 2, 1, 2] : [2, 2, 2, 2];
    o.lift = f % 2 ? 0 : -1;
    o.armL = f === 0 ? -1 : f === 2 ? 1 : 0; o.armR = -(o.armL as number);
  } else {
    if (Math.sin(a.t * 2.6) > 0.55) { o.lift = 1; o.legs = [1, 1, 1, 1]; }
    if (a.blinkT < 0) o.blink = true;
  }
  return o;
}
